// TODO - remove lint disable when editing this file
/* eslint-disable */
import BaseConverter from './BaseConverter'
import { hasIn, omit } from 'lodash'

export default class AtomicBaseConverter extends BaseConverter {
  constructor(ansType = '__fallback', draftTypes = ['atomic']) {
    super(ansType, draftTypes)
  }

  populateMetaData(ansData, [block]) {
    if (ansData) {
      const blockData = block.getData().toJS()
      // Make sure we still populate default data
      const defaultData = this.withDefaultData(blockData)
      ansData = Object.assign(
        {},
        defaultData,
        omit(ansData, ['alignment', 'channels'])
      )
      // Set comments if present
      if (hasIn(blockData, 'additionalProperties.comments')) {
        if (!ansData.additional_properties) {
          ansData.additional_properties = {}
        }
        ansData.additional_properties.comments =
          blockData.additionalProperties.comments
      }
    }

    return ansData
  }
}
